<template>
	<div style="margin: 0 auto;">
		<header-list></header-list>
		
		<div class="hblogo pb-30"><img style="max-width:800px;margin: 0 auto;display: block;" src="../assets/images/image1.png"></div>
		<Carousel autoplay  loop dots="none" auto  :height="600" trigger="hover" :autoplay-speed="5000" >
				<CarouselItem v-for="item in index_swi" :key="item.pub_picBig"  class="shou">
						<img class="nav-swiper-img" @click="enterDetail(item.DOC_SOURCEURL)" :src="item.pub_picBig" />
				</CarouselItem>
		</Carousel>
		
		
		<div class="dzb">
			<!--安徽画报年份B-->
			<div class="body-box mt-20" style="margin-top: 20px;">
				<div class="timer-shaft-box flex-x-e flex">
					<div style="width: 120px;">
						<select v-model="cats" class="select"   @change="changeCate">
								<option v-for="item in yearList"  :value="item.id" :key="item.id">{{ item.text }}</option>
						</select>
					</div>
					<div class="timer-shaft mt-20">
						<div class="timer-left" @click="changeIndex('-')"></div>
						<div class="timer-right" @click="changeIndex('+')"></div>
						<div class="timer-scale" :style="'left: -' + left +'px'">
							<div class="timer-scale-cont " :key="index" @click="changeCats(item.id,index)" v-for="item,index in yearList" :class="cats == item.id?'hov':''">
								<p class="time-circle">{{item.text}}</p>
								<p class="line-scale"></p>
							</div>
						</div>
					</div>
					<div class="timer-shaft-content">
						<div class="shaft-detail-cont" style="display: block;">
							<p class="timer-year" v-if="yearList.length"><i class="icon-year"></i><span>{{yearList[index].text}}年</span></p>
							<!-- 杂志开始 -->
							<div class="container">
								<div class="row">
									<div class="box" @click="bindlinkTo1(item.SYS_DOCUMENTID)" :key="index" v-for="item,index in img_list">
										<img :src="item.COVERPATH">
										<div class="box-content">
											<h3 class="title">{{item.SYS_TOPIC}}</h3>
										</div>
										<ul class="icon">
											<li @click.stop="collectopt(837,item.SYS_DOCUMENTID)"><a href="javascript:;" title="收藏"><i class="fa fa-link">藏</i></a></li>
										</ul>
									</div>
								</div>
							</div>
							<!--end-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--年份E-->



		<!-- footer -->
		<div class="wave-box">

			<div class="marquee-box marquee-up" id="marquee-box">
				<div class="marquee">
					<div class="wave-list-box" id="wave-list-box1">
						<ul>
							<li><img height="60" alt="波浪" src="../assets/images/img/wave_02.png"></li>
						</ul>
					</div>
					<div class="wave-list-box" id="wave-list-box2">
						<ul>
							<li><img height="60" alt="波浪" src="../assets/images/img/wave_02.png"></li>
						</ul>
					</div>
				</div>
			</div>


			<div class="marquee-box" id="marquee-box3">
				<div class="marquee">
					<div class="wave-list-box" id="wave-list-box4">
						<ul>
							<li><img height="60" alt="波浪" src="../assets/images/img/wave_01.png"></li>
						</ul>
					</div>
					<div class="wave-list-box" id="wave-list-box5">
						<ul>
							<li><img height="60" alt="波浪" src="../assets/images/img/wave_01.png"></li>
						</ul>
					</div>
				</div>
			</div>

		</div>
		<div class="footer">
			<div class=" ">
				<!-- footer主要-->


				<div class="footer-floor1 flex">
					<div class="footer-list">
						<ul>
							<li class="flist-title">关于我们</li>
							<li v-for="item,index in about_list" :key="index"  @click.stop="bindlinkTo('/about?id=' + item.id,item.SYS_TOPIC)"><a href="javascript:;"><strong>{{item.SYS_TOPIC}}</strong></a></li>
						</ul>
						<ul>
							<li class="flist-title">图片</li>
							<li @click.stop="bindlinkTo('/img_list?cats=29253&navid=88','历史图片')"><a href="javascript:;">历史图片</a></li>
							<li @click.stop="bindlinkTo('/img_list?cats=13614&navid=110','新闻图片')"><a href="#">新闻图片</a></li>
							<li @click.stop="bindlinkTo('/img_list?cats=168715&navid=111','美好安徽')"><a href="#">美好安徽</a></li>
							<li @click.stop="bindlinkTo('/img_list?cats=195917&navid=112','设计素材')"><a href="#">设计素材</a></li>
							<li @click.stop="bindlinkTo('/special_list?navid=113','专题图片')"><a href="#">专题图片</a></li>
						</ul>
						<ul>
							<li class="flist-title">视频</li>
							<li  v-for="item,index in bottom_sp" :key="index" @click.stop="bindlinkTo(item.url,item.name)"><a href="javascript:;">{{item.name}}</a></li>
						</ul>
						<ul class="flist-4">
							<li class="flist-title">音频</li>
							<li  v-for="item,index in bottom_yp" :key="index"  class="f-14 link mt-10 flex shou" @click.stop="bindlinkTo(item.url,item.name)"><a href="javascript:;">{{item.name}}</a></li>

						</ul>
						<div class="clear-float"></div>
					</div>
					<div class="footer-right">
						<div class="telephone" title="服务热线">
							<span></span>
							<div class="tel-number">0551-64376898</div>
						</div>
						<div class="official-plat">
							<p class="weixin" style="background-image: "><span id="wx-corner"></span></p>

							<p class="weibo" style="background-image: "><span id="wb-corner"></span></p>
							<ul>
								<li><a href="#a_null"><span class="weixin-logo"></span>安徽画报官方微信</a></li>
								<!-- <li><span class="weibo-logo"></span>市场星报官方微信</li> -->
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-floor2">
				<p>安徽画报 版权所有 2021 皖ICP备10200519号-7 Powered by 图片安徽 　广告热线/传真：0551-64376898</p>
				<p></p>
			</div>
		</div>
		<!-- footer end -->
	</div>
</template>

<script>

	import headerList from './header_nav.vue'
	export default {
		data() {
			return {
				cats: '2021',
				left: 0,
				index: 0,
				yearList: [],
				img_list: [],
				about_list: [],
				bottom_sp: [],
				bottom_yp: [],
				index_swi: [],
				childModal1: ''
			}
		},

		components: {
			headerList
		},
		
		created() {},
		
		mounted () {	
			this.imgcateList()
			this.bindBottom()
			this.bindBottomvideo()
			this.bindBottommusic()
			this.bindSwipe()
		},

		methods: {
			// 获取图分类接口
			async imgcateList (parentId=0) {
				let _this = this
				const res = await _this.get_res('/catsByCatCode', {catTypeCode: 'MATERIAL-PIC', parentId: '197517'})
				console.log(res);
				res.forEach(x => x.text = x.text.substr(0,4))
				_this.yearList = res.reverse()
				_this.cats = _this.yearList[0].id
				_this.datalist()
			},
			
			changeCate (a) {
				let _this = this
				// console.log(_this.cats)
				// _this.cats = a
				_this.index = _this.yearList.findIndex( x=> x.id == _this.cats)
				if (_this.index  >= _this.yearList.length-6) {
					_this.left = 135 * (_this.yearList.length-6)
				} else {
					_this.left = 135 * _this.index 
				}
				_this.datalist()
			},
			
			changeCats (id,index) {
				let _this = this
				_this.cats = id
				_this.index = index
				if (index >= _this.yearList.length-6) {
					_this.left = 135 * (_this.yearList.length-6)
				} else {
					_this.left = 135 * index
				}
				_this.datalist()
			},
			
			changeIndex (type) {
				let _this = this
				if (type == '-') {
					if (_this.index == 0) {
						return
					}
					_this.index = _this.index -1
					_this.cats = _this.yearList[_this.index].id
					_this.datalist()
				} else {
					if (_this.index == _this.yearList.length-1) {
						return
					}
					_this.index = _this.index + 1
					_this.cats = _this.yearList[_this.index].id
					_this.datalist()
				}
				
				if (_this.index >= _this.yearList.length-6) {
					_this.left = 135 * (_this.yearList.length-6)
				} else {
					_this.left = 135 * _this.index
				}
			},
			
			async datalist () {
				let _this = this
				_this.$Spin.show()
				let data = {}
				data.cats = _this.cats
				data.size = 12
				data.page = 0
				// data.t = 25
				data.sld = "AHSCXB"
				data.sort='LSSUE_NUM_i,desc'
				const res = await _this.get_res('/search',data)
				_this.img_list = res.content
				// _this.totalPages = res.totalPages
				// _this.total = res.totalElements
				_this.$Spin.hide()
			},
			
			// 跳转
			bindlinkTo (path,name) {
				if (path == '/index') {
					this.$router.push({path,query: {name}})
				} else {
					let link = this.$router.resolve({
						path, //要跳转的路由
						query: {
							name
						}
					});
					window.open(link.href, "_blank"); //打开新窗口
				}
			},
			
			bindlinkTo1 (path) {
				// location.href = 'http://www.tpahw.com/book/index.html?id=1892867&tid=837'
				window.open(this.$baseURL+'/book/index.html?id='+path+'&tid=837'); //打开新窗口
			},
			
			// 获取尾部关于我们部分
			async bindBottom () {
					 let _this = this
					 let data = { 
					 			conditions:JSON.stringify([{pub_col_id:82},{pub_sale_status:1}]),
					 			orderBy: "pub_a_order asc pub_lastmodified desc id asc",
					 			pageNo:1,
					 			pageSize:15,
					 			searchText:"",
					 		}
					 const res = await _this.post('/spc/cms/publish/list.do', data )
					 if ( res.success) {
					 	 _this.about_list = res.result
					 } else {
					 		_this.$Message.error(res.description);
					 }
			},
			
			// 获取尾部视频分类部分
			async bindBottomvideo () {
					 let _this = this
					 const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=47',{})
					 if (res.data.length) {
							 _this.bottom_sp = res.data
					 }
			},
			// 获取尾部视频分类部分
			async bindBottommusic () {
					 let _this = this
					 const res = await _this.post('/spc/cms/col/getColNextLevelNode?colId=51',{})
					 if (res.data.length) {
							 _this.bottom_yp = res.data
					 }
			},
			
			// 获取轮播图
			async bindSwipe (page) {
				let _this = this
				let data = { 
							conditions:JSON.stringify([{pub_col_id: 125},{pub_sale_status:1}]),
							orderBy: "pub_a_order asc pub_lastmodified desc id asc",
							pageNo:1,
							pageSize:15,
							searchText:"",
						}
				const res = await _this.post('/spc/cms/publish/list.do', data )
				// console.log(res)
				if ( res.success) {
						 _this.index_swi = res.result
				} else {
						_this.$Message.error(res.description);
				}
			},
			
			// 收藏操作
			async collectopt (a,b) {
						 let _this = this
					
							 const res = await _this.util.collect(a, b)
							 if (res.code == 401) {
								 return _this.$Message.error({
										content: res.message,
										duration: 3
									});
							 } else {
								 return _this.$Message.error({
										content: res.iMessage,
										duration: 3
									});
							 }

			},
			
			
		},
		
	}
	
</script>

<style lang="less" scoped>
	.nav-swiper-img {height: 600px;width: 100%;}
	.timer-shaft-content {
		width: 97.5%;
	}
	.select {
		display: inline-block;
		width: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		vertical-align: middle;
		color: #515a6e;
		font-size: 14px;
		line-height: normal;
		padding: 5px 3px;
	}
	@import '../assets/css/bootstrap.min.css';
	@import '../assets/css/journal/head.css';
	@import '../assets/css/journal/reset.css';
</style>
